/**
 * InfoPanel
 * Reusable panel for displaying bullet point lists with a title
 */

import { makeStyles, tokens, Text } from '@fluentui/react-components'
import type { InsightContentItem } from '../../../../domain'
import { PanelHeader } from '../shared'
import { usePanelContainerStyles } from '../../styles/usePanelContainerStyles'

const useStyles = makeStyles({
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    margin: 0,
    paddingLeft: tokens.spacingHorizontalL,
  },
  listItem: {
    color: tokens.colorNeutralForeground2,
  },
  emptyState: {
    color: tokens.colorNeutralForeground3,
    fontStyle: 'italic',
  },
})

export interface InfoPanelProps {
  title: string
  icon?: React.ReactNode
  items: InsightContentItem[]
  emptyMessage?: string
}

export function InfoPanel({ title, icon, items, emptyMessage = 'No items' }: InfoPanelProps) {
  const containerStyles = usePanelContainerStyles()
  const styles = useStyles()

  return (
    <div className={containerStyles.root}>
      {icon && <PanelHeader icon={icon} title={title} />}
      {!icon && <Text weight="semibold">{title}</Text>}
      {items.length > 0 ? (
        <ul className={styles.list}>
          {items.map((item) => (
            <li key={item.id}>
              <Text size={200} className={styles.listItem}>
                {item.content}
              </Text>
            </li>
          ))}
        </ul>
      ) : (
        <Text size={200} className={styles.emptyState}>
          {emptyMessage}
        </Text>
      )}
    </div>
  )
}
